import { render } from "./WidgetBhagLinkverwaltung.vue?vue&type=template&id=7fce89b6&scoped=true&ts=true"
import script from "./WidgetBhagLinkverwaltung.vue?vue&type=script&lang=ts"
export * from "./WidgetBhagLinkverwaltung.vue?vue&type=script&lang=ts"

import "./WidgetBhagLinkverwaltung.vue?vue&type=style&index=0&id=7fce89b6&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fce89b6"]])

export default __exports__